<template>
  <div class="veda-cooperationDetail">
    <div class="senior-content">
      <div class="web-box12 senior-wrap">
        <img class="swiper" :src="datas.cover" />
        <p class="title">{{datas.title}}</p>
        <div style="padding-bottom:20px;">
          <img class="heard" :src="datas.icon" />
          <span class="name">{{datas.brand}}</span>&emsp;&emsp;
          <span>行业：{{datas.name}}</span>
          <!-- <p>
              <span class="icon">&#xe627;</span>
              <span class="tag" v-for="(item,index) in datas.name_num" :key="index">{{item}}</span>
          </p>-->
        </div>
      </div>
    </div>
    <div class="web-box12" style="margin-top:50px;">
      <a-row type="flex" justify="center">
        <a-col v-for="(item,index) in  datas.name_num" :key="index" :xs="24" :sm="6">
          <div :class="['data-item',{'left-border':index!=0}]">
            <h3>
              {{item.num}}
              <span>{{item.unit}}</span>
            </h3>
            <p>{{item.name}}</p>
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="web-box12" style="margin-top:30px;">
      <h2 class="label">品牌投放亮点</h2>
      <div v-html="datas.content"></div>
    </div>
    <div class="web-box12" style="margin-top:30px;">
      <h2 class="label">其他案例推荐</h2>
      <div class="web-box12 cooperation-content">
        <div v-for="item in cooperList" @click="goToDetail(item.id)" :key="item.id" class="card">
          <div class="banner" :style="{backgroundImage:`url(${item.cover})`}">
            <div class="tag">
              <!-- <p>食品饮料类&emsp;饮料 | 微博热搜榜</p> -->
            </div>
          </div>
          <p class="title">{{item.title}}</p>
          <div class="brand">
            <img :src="item.icon" />
            <p>{{item.brand}}</p>
            <!-- <p class="font10">2019.10.15-2019.10.16投放</p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tagList: ["达人", "娱乐营销", "电商引流"],
      datas: {
        name_num: []
      },
      cooperList: []
    };
  },
  mounted() {
    this.query();
  },
  methods: {
    query() {
      this.$jsonp(
        `http://h5.vedamobi.com/index.php/api/api/get_case_detail?id=${this.$route.query.id}`,
        {},
        (error, data) => {
          if (data && data.code === 200) {
            this.total = data.total;
            this.datas = data.data;
            this.cooperList = data.data.random;
          } else {
            this.$message.error(`${error},${data.msg}`);
          }
        }
      );
    },
    unitConversion(numb) {
      if (numb.length < 5) {
        return numb;
      } else if (numb.length >= 5 && numb.length < 9) {
        return Math.round(numb / 100) / 100;
      } else {
        return Math.round(numb / 1000000) / 100;
      }
    },
    unitKey(numb) {
      if (numb.length < 5) {
        return "";
      } else if (numb.length >= 5 && numb.length < 9) {
        return "万";
      } else {
        return "亿";
      }
    },
    goToDetail(id) {
      this.$router.replace({
        path: "refershs",
        query: {
          id
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.web-box12 {
  width: 100%;
  max-width: 1240px;
  padding: 0 20px;
  margin: 0 auto;
}
.senior-wrap {
  color: #d5dce6;
  .swiper {
    width: 100%;
    height: auto;
  }
  .title {
    font-weight: 400;
    font-size: 28px;
    line-height: 38px;
    margin: 16px 0;
  }
  .heard {
    width: 40px;
    height: 40px;
    border-radius: 100%;
  }
  .name {
    font-size: 18px;
    line-height: 40px;
    margin-left: 5px;
  }
  .icon {
    font-family: "iconfont";
  }
  .tag {
    padding: 0 8px;
    font-size: 12px;
    line-height: 16px;
    background-color: #3d3d46;
    border-radius: 8px;
    white-space: nowrap;
    margin-left: 10px;
  }
}
.senior-content {
  width: 100%;
  background-color: #2c2c31;
  padding-top: 72px;
}
.data-item {
  margin-top: 20px;
  width: 100%;
  text-align: center;
  padding: 0 20px;
  h3 {
    font-size: 60px;
    color: #f8633b;
    line-height: 67px;
    padding-bottom: 4px;
    font-weight: 400;
    margin-bottom: 10px;
    span {
      font-size: 12px;
      color: #333;
    }
  }
  p {
    font-size: 24px;
    color: #333;
  }
}
.left-border {
  border-left: 1px solid #eee;
}
.label {
  font-size: 22px;
  color: #354052;
  margin-bottom: 24px;
}
.cooperation-content {
  display: flex;
  flex-wrap: wrap;
  .card {
    border: 1px solid #f1f1f1;
    width: calc(25% - 20px);
    margin-top: 20px;
    margin-left: 20px;
    background-color: #fff;
    padding-bottom: 10px;
    border-radius: 7px;
    overflow: hidden;
    transition: all 0.2s ease-out;
    &:hover {
      transform: translateY(-4px);
      box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
    }
    .banner {
      width: 100%;
      height: 164px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50%;
      position: relative;
      .tag {
        color: #fff;
        padding: 12px 12px 8px;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background-image: linear-gradient(
          to top,
          rgba(0, 0, 0, 0.4),
          transparent
        );
        p {
          margin: 0;
        }
      }
    }
    .title {
      font-size: 16px;
      margin: 0;
      width: 100%;
      padding: 6px 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
      &:hover {
        color: #8899f2;
      }
    }
    .brand {
      margin: 0 12px;
      img {
        width: 28px;
        height: 28px;
        border-radius: 100%;
        float: left;
      }
      p {
        position: relative;
        left: 14px;
        line-height: 28px;
        margin: 0;
      }
      p:nth-child(2) {
        font-size: 14px;
      }
      p:nth-child(3) {
        font-size: 12px;
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .cooperation-content {
    display: flex;
    .card {
      width: 100%;
      margin-left: 0;
    }
    .screen {
      margin: 80px 0 0 0px;
    }
  }
}
@media screen and (min-width: 577px) and (max-width: 992px) {
  .cooperation-content {
    display: flex;
    .card {
      width: calc(50% - 20px);
    }
  }
}
@media screen and (min-width: 993px) and (max-width: 1200px) {
  .cooperation-content {
    display: flex;
    .card {
      width: calc(33% - 20px);
    }
  }
}
</style>